module.exports = __webpack_public_path__ + "img/baiduHead.7cf18a08.png";